<form fxLayout="column" (ngSubmit)="onSubmit()">
  <mat-form-field appearance="outline">
    <mat-label>Email</mat-label>
    <mat-icon matPrefix>mail</mat-icon>
    <input
      #emailInput
      name="email"
      matInput
      [(ngModel)]="email"
      type="email"
      required
      (ngModelChange)="emailValid = null; willingToCreateNewAccount = null"
    />
  </mat-form-field>
  <mat-form-field appearance="outline" *ngIf="emailValid === true">
    <mat-label>{{
      willingToCreateNewAccount ? "Scegli una password" : "Password"
    }}</mat-label>
    <mat-icon matPrefix>star</mat-icon>
    <input
      #passwordInput
      name="password"
      matInput
      [(ngModel)]="password"
      type="password"
      required
    />
  </mat-form-field>
  <p style="text-align: center">
    <button
      mat-raised-button
      color="primary"
      type="submit"
      *ngIf="emailValid === null"
    >
      Avanti
    </button>
    <button
      mat-raised-button
      color="primary"
      type="submit"
      *ngIf="emailValid === true"
    >
      {{ willingToCreateNewAccount ? "Crea account" : "Accedi" }}
    </button>
  </p>
  <p
    style="text-align: center"
    *ngIf="emailValid && willingToCreateNewAccount !== true"
  >
    <small
      ><a href="javascript:void(0)" (click)="resetPassword()"
        >Password dimenticata?</a
      ></small
    >
  </p>
</form>
